/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-underscore-dangle */
import React, { useRef, useEffect, useState } from 'react';
import { Container, Row, Col } from 'reactstrap';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import BarChart from '@material-ui/icons/BarChart';
import { Button, TextField } from '@material-ui/core';
import { withRouter, Redirect } from 'react-router-dom';
import MaterialTable from 'material-table';
import elearningServices from '../../../../redux/services/elearningServices';
import groupActions from '../../../../redux/actions/groupActions';
import AddStudents from './AddStudents';
import { Loading } from '../../../../helpers/utils';
import groupServices from '../../../../redux/services/groupServices';
import userServices from '../../../../redux/services/userServices';

const SubGroups = (props) => {
  const [subGroupName, setSubGroupName] = useState('');
  const [group] = useState(props.focusGroup);
  const [subGroups, setSubGroups] = useState(props.focusGroup.elearning.subGroups);
  const [loading, setLoading] = useState(false);
  const [redirect, setRedirect] = useState(null);
  const [allStudents, setAllStudents] = useState([]);
  const refTable = useRef();

  useEffect(() => {
    setLoading(true);
    userServices.getStudentsWithoutGrade(props.company?.company._id)
      .then((res) => {
        setLoading(false);
        setAllStudents(res);
      })
      .catch(() => {
        setLoading(false);
      });
  }, []);

  const addSubGroup = async () => {
    setLoading(true);
    await elearningServices.updateSubGroup(group.elearning._id, { name: subGroupName.length === 0 ? 'Nouveau Groupe' : subGroupName, listIdUsers: [] })
      .then((res) => {
        setLoading(false);
        setSubGroups(res.subGroups);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const removeStudentToGroup = async (subgroupid, studentIds) => {
    setLoading(true);
    await elearningServices.updateSubGroupUsers(group.elearning._id, subgroupid, { add: false, studentIds })
      .then((res) => {
        setLoading(false);
        setSubGroups(res.subGroups);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const addStudentToGroup = async (subgroupid, studentIds) => {
    await elearningServices.updateSubGroupUsers(group.elearning._id, subgroupid, { add: true, studentIds })
      .then((res) => {
        setSubGroups(res.subGroups);
      });
  };

  const removeSubGroup = async (subgroupId) => {
    setLoading(true);
    await elearningServices.updateSubGroup(group.elearning._id, { _id: subgroupId, remove: true })
      .then((res) => {
        setLoading(false);
        setSubGroups(res.subGroups);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const renameGroup = (newData) => {
    const tmp = newData;
    setLoading(true);
    tmp.listIdUsers = tmp.listIdUsers.map((el) => el._id);
    elearningServices.updateSubGroup(group.elearning._id, tmp)
      .then((res) => {
        setLoading(false);
        setSubGroups(res.subGroups);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  if (redirect !== null) {
    const res = JSON.parse(JSON.stringify({
      ...redirect,
      groupid: group._id,
    }));
    props.setSelectedGroup(group);
    props.setSelectedSubGroup(redirect);
    return (
      <Redirect
        to={{
          pathname: `/subgroups/results/${redirect._id}`,
          state: {
            subgroup: res,
            group,
          },
        }}
      />
    );
  }
  return (
    <>
      <Container className="group-creation-container-centered">
        <Col className="group-creation-card" style={{ minHeight: 0 }}>
          <Row style={{ marginBottom: 25 }}>
            <Col md={4}>
              <h3>{`Sous-groupes pour ${props.company?.company.name} semestre ${group.semester}`}</h3>
            </Col>
            <Col md={1} />
            <Col md={4}>
              <TextField
                onChange={(e) => setSubGroupName(e.target.value)}
                id="outlined-uncontrolled"
                variant="outlined"
                placeholder="Nom du sous-groupe"
                value={subGroupName}
                fullWidth
              />
            </Col>
            <Col md={3}>
              <Button
                variant="contained"
                style={{
                  height: 56, width: '100%', paddingLeft: 20, paddingRight: 20, backgroundColor: '#3f51b5', color: 'white',
                }}
                onClick={() => addSubGroup()}
              >
                + Sous-groupe
              </Button>
            </Col>
            <Col md={12} style={{ marginTop: 25 }}>
              {
                loading
                  ? <Loading />
                  : (
                    <MaterialTable
                      options={{
                        showTitle: false,
                        search: false,
                        toolbar: false,
                        paging: false,
                        headerStyle: {
                          color: 'white',
                          backgroundColor: '#3f51b5',
                        },
                      }}
                      localization={{
                        body: {
                          emptyDataSourceMessage: (
                            'Pas encore de sous-groupe, créez-en un !'
                          ),
                        },
                      }}
                      components={{
                        OverlayLoading: () => (<Loading />),
                      }}
                      title="Sous-groupes"
                      columns={[
                        {
                          title: 'Nom',
                          field: 'name',
                        },
                        {
                          title: 'Étudiants',
                          field: 'listIdUsers.length',
                          width: '20%',
                          editable: false,
                          render: (rowData) => {
                            let count = 0;
                            rowData.listIdUsers.forEach((user) => {
                              if (user.semester === group.semester) {
                                count += 1;
                              }
                            });
                            return count;
                          },
                        },
                        {
                          title: '',
                          width: '10%',
                          align: 'right',
                          field: '',
                          editable: false,
                          render: (rowData) => 'Cliquez pour ajouter des étudiants',
                        },
                      ]}
                      style={{
                        width: '100%',
                        height: '100%',
                      }}
                      data={subGroups}
                      tableRef={refTable}
                      onRowClick={(index, row) => {
                        if (row) {
                          refTable.current.onToggleDetailPanel([row.tableData.id], (rowData) => <AddStudents allStudents={allStudents} group={group} subGroups={subGroups} subgroupStudents={rowData.listIdUsers} subGroupId={rowData._id} addStudentToGroup={addStudentToGroup} removeStudentToGroup={removeStudentToGroup} />);
                        }
                      }}
                      detailPanel={(rowData) => (
                        <Col md={12}>
                          <AddStudents allStudents={allStudents} group={group} subGroups={subGroups} subgroupStudents={rowData.listIdUsers} subGroupId={rowData._id} addStudentToGroup={addStudentToGroup} removeStudentToGroup={removeStudentToGroup} />
                        </Col>
                      )}
                      editable={{
                        onRowDelete: (oldData) => new Promise((resolve) => {
                          removeSubGroup(oldData._id)
                            .then(() => {
                              resolve();
                            });
                        }),
                        onRowUpdate: (newData) => new Promise((resolve) => {
                          renameGroup(newData);
                          resolve();
                        }),
                      }}
                    />
                  )
              }
            </Col>
          </Row>
        </Col>
      </Container>
    </>
  );
};

function mapStateToProps(state) {
  const name = `group_${state.group.selectedGroup._id}`;
  const { company } = state;
  const group = state.group.selectedGroup;
  const dataform = state.form[`group_${state.group.selectedGroup._id}`];
  return {
    initialValues: state.group.selectedGroup, form: name, dataform, company, focusGroup: group,
  };
}

const connectedGroupForm = reduxForm({
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false,
})(SubGroups);

const actionCreators = {
  setSelectedGroup: groupActions.setSelectedGroup,
  setSelectedSubGroup: groupActions.setSelectedSubGroup,
  getAll: groupActions.getAll,
};

const NewconnectedGroupForm = connect(
  mapStateToProps,
  actionCreators,
)(injectIntl(connectedGroupForm));

export default withRouter(NewconnectedGroupForm);
